module.exports = __webpack_public_path__ + "img/homeBg7.9f7df5b9.png";